import React from 'react'
import { FieldRenderProps, FieldWrapper } from '@progress/kendo-react-form'
import { Label, Error, Hint } from '@progress/kendo-react-labels'

const FormCustomField = (fieldRenderProps: FieldRenderProps) => {
    const {
        validationMessage,
        touched,
        label,
        id,
        valid,
        disabled,
        hint,
        wrapperStyle,
        required,
        value,
        valueObject,
        children,
        ...others
    } = fieldRenderProps

    const showValidationMessage = touched && validationMessage
    const showHint: boolean = !showValidationMessage && hint
    const hintId = showHint ? `${id}_hint` : ''
    const errorId = showValidationMessage ? `${id}_error` : ''
    const labelId = label ? `${id}_label` : ''

    return (
        <FieldWrapper style={wrapperStyle}>
            <Label
                id={labelId}
                editorId={id}
                editorValid={valid}
                editorDisabled={disabled}
            >
                {required &&
                    <span className='text-danger'>*</span>
                }
                {label} &nbsp;
                {
                    showValidationMessage &&
                    <Error id={errorId}>{validationMessage}</Error>
                }
            </Label>
            {React.cloneElement(
                children, {
                ...children.props,
                valid,
                id: id || children.props.id,
                disabled,
                ariaLabelledBy: labelId,
                ariaDescribedBy: `${hintId} ${errorId}`,
                value: valueObject ? valueObject : value,
                ...others,
                ...children.props
            })}
            {showHint && <Hint id={hintId}>{hint}</Hint>}
        </FieldWrapper>
    )
}

export default FormCustomField